import React__default from 'react';
import PropTypes from 'prop-types';
import { a as IconNames } from './types-6e7da022.js';
import { S as SvgAdd } from './add-4a4fe5c2.js';
import { S as SvgFilter } from './filter-a4af09e9.js';
import { S as SvgLoading } from './loading-6cabb422.js';
import { S as SvgMagnifyingGlass } from './magnifying-glass-3c43cfbb.js';
import { S as SvgSearch } from './search-42d3c9cc.js';
import { S as SvgDown } from './down-f9e6ad7e.js';
import { S as SvgCloseThin } from './close-thin-a9749b58.js';
import { S as SvgTickFilled } from './tick-filled-fbbd6819.js';

const {
  ADD,
  CLEAR,
  FILTER,
  LOADING,
  MAGNIFYING_GLASS,
  NONE,
  SEARCH,
  SELECT,
  VALIDATE_SUCCESS
} = IconNames;
const IconRouter = ({
  iconName
}) => {
  const iconMap = {
    [ADD]: /*#__PURE__*/React__default.createElement(SvgAdd, null),
    [CLEAR]: /*#__PURE__*/React__default.createElement(SvgCloseThin, null),
    [FILTER]: /*#__PURE__*/React__default.createElement(SvgFilter, null),
    [LOADING]: /*#__PURE__*/React__default.createElement(SvgLoading, null),
    [MAGNIFYING_GLASS]: /*#__PURE__*/React__default.createElement(SvgMagnifyingGlass, null),
    [NONE]: null,
    [SEARCH]: /*#__PURE__*/React__default.createElement(SvgSearch, null),
    [SELECT]: /*#__PURE__*/React__default.createElement(SvgDown, null),
    [VALIDATE_SUCCESS]: /*#__PURE__*/React__default.createElement(SvgTickFilled, null)
  };
  return iconMap[iconName] || null;
};
IconRouter.defaultValues = {
  iconName: IconNames.NONE
};
IconRouter.propTypes = {
  iconName: PropTypes.oneOf(Object.values(IconNames))
};

export { IconRouter as default };
